import GetOffset from '../_utils/GetOffset';
import Swipes from '../_utils/Swipes';

const TRANSITION_DURATION = 1000;

export default class Resources {


	// Constructor
	constructor(element) {
		this.element = element;

		this.buttonClick = this.buttonClick.bind(this);
		this.timerFired = this.timerFired.bind(this);

		this.buttonNext = this.element.querySelector('.paged-buttons--next');
		this.buttonPrev = this.element.querySelector('.paged-buttons--prev');
		this.buttonSlug = this.element.querySelector('.card-slug');

		this.cards = Array.prototype.slice.call(this.element.querySelectorAll('.card-resource'), 0);
		this.numberCurrent = this.element.querySelector('.paged-buttons--total strong');
		this.numberTotal = this.element.querySelector('.paged-buttons--total span');

		this.buttonNext.addEventListener('click', this.buttonClick);
		this.buttonPrev.addEventListener('click', this.buttonClick);
		this.buttonSlug.addEventListener('click', this.buttonClick);

		this.imageNext = null;
		this.imagePrev = null;

		this.clickEnabled = true;
		this.page = -1;
		this.scrollEnabled = true;
		this.scrollMin = -1;
		this.timer = null;

		this.itemsPerPage = 1;
		this.totalPages = 1;

		this.swiped = this.swiped.bind(this);
		new Swipes(this.element, this.swiped);

	}


	// Public Methods
	changePage(page) {
		if (this.clickEnabled === false) {
			return;
		}
		if (page !== this.page && page >= 0 && page < this.totalPages) {
			const prev = this.page;
			this.page = page;
			this.updateCards(prev);
			this.clickEnabled = false;
			this.timer = setTimeout(this.timerFired, TRANSITION_DURATION);
		}
	}
	resize() {
		const windowWidth = window.innerWidth;
		if (windowWidth >= 940) {
			this.itemsPerPage = 3;
		} else if (windowWidth >= 620) {
			this.itemsPerPage = 2;
		} else {
			this.itemsPerPage = 1;
		}
		this.totalPages = Math.ceil(this.cards.length / this.itemsPerPage);
		if (this.page > -1) {
			if (this.page >= this.totalPages) {
				this.page = this.totalPages - 1;
			}
			this.updateCards(-1);
		}

		if (this.scrollEnabled) {

			const elementTop = GetOffset.top(this.element);
			const windowHeight = window.innerHeight;

			const elementAppear = elementTop - windowHeight;
			this.scrollMin = elementAppear + 100;

			this.scroll();
		}
	}
	scroll() {
		if (this.scrollEnabled && this.scrollMin !== -1) {
			const scrollY = window.pageYOffset;
			if (scrollY >= this.scrollMin) {
				this.element.classList.add('play');
				this.scrollEnabled = false;
				this.changePage(0);
			}
		}
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		if (event.currentTarget === this.buttonPrev) {
			this.changePage(this.page - 1);
		} else {
			this.changePage(this.page + 1);
		}
	}
	swiped(direction) {
		if (direction === 'left') {
			this.changePage(this.page - 1);
		} else if (direction === 'right') {
			this.changePage(this.page + 1);
		}
	}
	timerFired() {
		this.updateCards(-1);
	}


	// Helpers
	displayNumber(number) {
		if (number < 10) {
			return '0' + number;
		}
		return number;
	}
	updateCards(prev) {

		this.clickEnabled = true;
		clearTimeout(this.timer);

		const pageStart = this.page * this.itemsPerPage;
		const pageEnd = pageStart + this.itemsPerPage;
		var prevStart = -1;
		var prevEnd = -1;
		if (prev > -1) {
			prevStart = prev * this.itemsPerPage;
			prevEnd = prevStart + this.itemsPerPage;
		}
		for (var i=0, l=this.cards.length; i<l; i++) {
			this.cards[i].classList.remove('current');
			this.cards[i].classList.remove('previous');
			if (i >= pageStart && i < pageEnd) {
				this.cards[i].classList.add('current');
			} else if (i >= prevStart && i < prevEnd) {
				this.cards[i].classList.add('previous');
			}
		}

		if (this.imagePrev !== null) {
			if (this.imagePrev.parentNode) {
					this.imagePrev.parentNode.removeChild(this.imagePrev);
				}
			this.imagePrev = null;
		}
		if (this.imageNext !== null) {
			this.imagePrev = this.imageNext;
			this.imagePrev.className = 'previous';
		}
		if (pageEnd < this.cards.length) {
			this.imageNext = document.createElement('i');
			this.imageNext.className = 'current';
			this.buttonSlug.appendChild(this.imageNext);
			const img = this.cards[pageEnd].querySelector('.card-resource--img');
			if (img) {
				const i = document.createElement('i');
				i.style.backgroundImage = img.style.backgroundImage;
				this.imageNext.appendChild(i);
			}
		}

		this.buttonNext.classList.remove('is-disabled');
		this.buttonPrev.classList.remove('is-disabled');
		if (this.page === this.totalPages - 1) {
			this.buttonNext.classList.add('is-disabled');
		}
		if (this.page === 0) {
			this.buttonPrev.classList.add('is-disabled');
		}

		this.numberCurrent.innerHTML = this.displayNumber(this.page + 1);
		this.numberTotal.innerHTML = this.displayNumber(this.totalPages);
	}


}
